// src/components/RaceSessionSelect.jsx
import { useEffect, useState } from "react";
import { fetchSheetViaProxy } from "../lib/sheets";

// Voller Bereich inkl. Kopfzeile
const RANGE = "Schedule!A1:B";

function toInt(v){
    const n = parseInt(String(v).trim(), 10);
    return Number.isFinite(n) ? n : null;
}

export default function RaceSessionSelect({
                                              valueRace,
                                              onRaceChange,
                                              valueSession,
                                              onSessionChange,
                                              showSession = true,
                                              onTrackLabelChange,           // gibt den Label "R1 – Track" nach oben
                                              valueClass,                   // ✅ NEU: Klasse (GESAMT / PRO / AM)
                                              onClassChange,                // ✅ NEU: Callback für Klasse
                                              showClass = false,            // ✅ NEU: ob das Klassen-Dropdown angezeigt wird
                                          }){
    const [options, setOptions] = useState([]); // [{id, track, label}]

    useEffect(() => {
        (async () => {
            try{
                const res = await fetchSheetViaProxy({ range: RANGE });

                let matrix = [];
                if (Array.isArray(res?.values)) {
                    matrix = res.values;                 // [[#, Track], [1, "Spa"], ...]
                } else if (Array.isArray(res?.rows)) {
                    matrix = res.rows.map(r => Object.values(r));
                }

                // Kopfzeile entfernen wenn erste Zelle nicht numerisch
                if (matrix.length && toInt(matrix[0]?.[0]) === null) {
                    matrix = matrix.slice(1);
                }

                const opts = matrix
                    .map(row => {
                        const id = toInt(row?.[0]);
                        const track = String(row?.[1] ?? "").trim();
                        if (!id) return null;
                        return { id, track, label: `R${id} – ${track}` };
                    })
                    .filter(Boolean)
                    .sort((a,b) => a.id - b.id);

                setOptions(opts);

                // Initiale Selektion / Tracklabel nach oben geben
                const current = opts.find(o => o.id === valueRace) ?? opts[0];
                if (current){
                    if (typeof valueRace !== "number") onRaceChange?.(current.id);
                    onTrackLabelChange?.(current.label);
                }
            }catch(e){
                console.warn("Schedule load failed", e);
                setOptions([]);
                onTrackLabelChange?.("");
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Bei Benutzerwechsel: Tracklabel mitschicken
    const handleRaceChange = (id) => {
        onRaceChange?.(id);
        const o = options.find(x => x.id === id);
        onTrackLabelChange?.(o ? o.label : "");
    };

    return (
        <div className="card" style={{ display:"grid", gap:8 }}>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {/* Rennen */}
                <label className="input" style={{ display:"inline-flex", alignItems:"center", gap:8 }}>
                    <span>Rennen</span>
                    <select
                        className="input"
                        value={valueRace ?? ""}
                        onChange={(e) => handleRaceChange(parseInt(e.target.value,10))}
                    >
                        {options.map(o => (
                            <option key={o.id} value={o.id}>{o.label}</option>
                        ))}
                    </select>
                </label>

                {/* Session (nur Results) */}
                {showSession && (
                    <label className="input" style={{ display:"inline-flex", alignItems:"center", gap:8 }}>
                        <span>Session</span>
                        <select
                            className="input"
                            value={valueSession ?? "RACE"}
                            onChange={(e) => onSessionChange?.(e.target.value)}
                        >
                            <option value="RACE">RACE</option>
                            <option value="QUALY">QUALY</option>
                            <option value="PRACTICE">PRACTICE</option>
                        </select>
                    </label>
                )}

                {/* Klasse (GESAMT / PRO / AM) */}
                {showClass && (
                    <label className="input" style={{ display:"inline-flex", alignItems:"center", gap:8 }}>
                        <span>Klasse</span>
                        <select
                            className="input"
                            value={valueClass ?? "GESAMT"}
                            onChange={(e) => onClassChange?.(e.target.value)}
                        >
                            <option value="GESAMT">Gesamt</option>
                            <option value="PRO">PRO</option>
                            <option value="AM">AM</option>
                        </select>
                    </label>
                )}
            </div>
        </div>
    );
}
